// Photo filenames for Holiday Party 2013
const HOLIDAY_PARTY_2013 = [
  'facebook-christmas-20138_16526837101_z.jpg',
  'facebook-christmas-20139_16340865778_z.jpg',
  'facebook-christmas-201310_16528577825_z.jpg',
  'facebook-christmas-201311_16502542406_z.jpg',
  'facebook-christmas-201312_16342271789_z.jpg',
  'facebook-christmas-201313_15908377813_z.jpg',
  'facebook-christmas-201315_16526842471_z.jpg',
  'facebook-christmas-201316_16341096240_z.jpg',
  'facebook-christmas-201317_16527510232_z.jpg',
  'facebook-christmas-201318_16340865198_z.jpg',
  'facebook-christmas-201319_15908377543_z.jpg',
  'facebook-christmas-201320_16526842231_z.jpg',
  'facebook-christmas-201321_16527511112_z.jpg',
  'facebook-christmas-201322_16342272239_z.jpg',
  'facebook-christmas-20132_16342677017_z.jpg',
  'facebook-christmas-20133_16341086680_z.jpg',
  'facebook-christmas-20134_16526833841_z.jpg',
  'facebook-christmas-20137_16502534876_z.jpg',
];

export default HOLIDAY_PARTY_2013;
